import * as React from 'react'

import {
  Box,
  SearchField,
  SortDirection,
  Table,
  useToggle,
} from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import CompetenciesDiscoveryModal from 'modules/job_catalog/components/CompetenciesDiscoveryModal'
import jobRolesCollection from 'modules/job_catalog/store/collections/roles'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import Body from './_Body'
import Header from './_Header'

type Props = {
  canManageCompetencies: boolean
}

const AssessmentsTable = ({ canManageCompetencies }: Props) => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const [direction, setDirection] = React.useState<SortDirection>('asc')
  const [sortAttribute, setSortAttribute] = React.useState<string>('name')

  const [hideDiscoveryModal, setHideDiscoveryModal] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideCompetenciesDiscoveryModalTip
  )
  const [isOpen, toggle] = useToggle(!hideDiscoveryModal)
  const canCreateJob = policyAuthorizations.for('job_catalog.create_job')

  const isRoleEditor = jobRolesCollection.some((x) =>
    policyAuthorizations.for('job_catalog.edit_job', x)
  )
  const showModal = isOpen && (canCreateJob || isRoleEditor || canManageCompetencies)

  useAsyncData(
    () =>
      Promise.all([
        policyAuthorizations.authorizePolicies('job_catalog.create_job'),
        policyAuthorizations.authorizePolicies('job_catalog.edit_job'),
      ]),
    []
  )

  const onSort = (sortAttr: string, dir: SortDirection) => {
    setSortAttribute(sortAttr)
    setDirection(dir)
  }

  const getTableOptions = () => (
    <Box flexGrow>
      <SearchField
        variant="big"
        search={search}
        onSearch={onSearch}
        placeholder={i18n.t('common.search')}
      />
    </Box>
  )

  return (
    <>
      <Table options={getTableOptions}>
        <Header sortAttribute={sortAttribute} direction={direction} onSort={onSort} />
        <Body sortAttribute={sortAttribute} direction={direction} search={debouncedSearch} />
      </Table>
      {showModal && (
        <CompetenciesDiscoveryModal
          onClose={() => {
            setHideDiscoveryModal(true)
            toggle(false)()
          }}
          handleOnComplete={() => setHideDiscoveryModal(true)}
        />
      )}
    </>
  )
}

export default observer(AssessmentsTable)
